const testimonials = [
  {
    id: 1,
    name: 'Njowe Brenda',
    title: 'Worshiper',
    org: 'Njowe choir',
    desc:
      'cedrick is a person of commitment. He is really good at what he is doing. I really like his work. Especially the unique point of view of designing and devlopment.',
  },
  {
    id: 2,
    name: 'Tueno Brell',
    title: 'Footballer',
    org: 'Tueno ngambe',
    desc:
      'Really amazing communication skills. Always understand what I am trying to achieve. Also, his work is really amazing. Do really high-quality work.',
  },
  {
    id: 3,
    name: 'Paulo',
    title: 'CEO of tchakap by pablo',
    org: 'Tchakap by Pablo',
    desc:
      'Really hard-working person. Deliver the work as promised. Planning to work more with this person.',
  },
];
export default testimonials;
